export async function getStudentClassDetail(jwt: string): Promise<any> {
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }
    // Successful response
    return {
        status: 200,
        data: {
            "feedback": [],
            "class_details": {
                "class_name": "Class Two",
                "auth_code": "BB111",
                "created_at": "02-02-2025",
                "discharged_patients": 4,
                "total_patients": 6,
                "average_score": 5.0
            },
            "disease_details": [
                {
                    name: "NSTEMIs",
                    no_of_patients: "2",
                    average_score: "4.2",
                },
                {
                    name: "STEMI",
                    no_of_patients: "3",
                    average_score: "3.2",
                },
                {
                    name: "Atrial Fibrillation",
                    no_of_patients: "1",
                    average_score: "4.5",
                }
            ],
            "patients": [{
                id: "6",
                name: "Marilyn Smith",
                demographics: "59 Female",
                symptom: "ABDOMINAL_PAIN",
                diagnosis: "NSTEMI",
                real_diagnosis: "STEMI_ANTERIOR",
                score: 80,
                feedback: "Good job",
            },
            {
                id: "7",
                name: "Fred Flintstone",
                demographics: "60 Male",
                symptom: "CHEST_PAIN",
                diagnosis: "NSTEMI",
                real_diagnosis: "STEMI_ANTERIOR",
                score: 90,
                feedback: "Good job",
            }]
        }
    };
}
